// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CGmCs","link":"styles_link__mfKXo","active":"styles_active__rxoxM","underlineAnimation":"styles_underlineAnimation__tBnMX"};